import { useCallback, useEffect, useState } from 'react'
import { sileo } from 'sileo'
import { useApp } from '../context/AppContext'
import ticketService from '../services/ticketService'

/**
 * Tickets de los que el usuario actual es AUTOR (los que él reportó).
 *
 * A diferencia de `useTickets` en modo `'own'` —que filtra por responsable
 * (`responsibleId = employee.id`)—, aquí se filtra por el creador
 * (`userId = auth.uid`), así que no depende de que el empleado esté hidratado.
 *
 * @param {Object} [options]
 * @param {number} [options.limit] - Sólo los N más recientes.
 * @returns {{ tickets: Array<Object>, loading: boolean, reload: Function }}
 */
export default function useMyTickets({ limit } = {}) {
  const { user } = useApp()
  const [tickets, setTickets] = useState([])
  const [loading, setLoading] = useState(true)
  const [reloadToken, setReloadToken] = useState(0)

  useEffect(() => {
    if (!user?.id) return
    let active = true

    ticketService
      .getByAuthor(user.id, { limit })
      .then(({ success, data, error }) => {
        if (!active) return
        if (!success) {
          sileo.error({
            title: 'Error cargando tus tickets',
            description: error,
          })
          setTickets([])
        } else {
          setTickets(data)
        }
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [user?.id, limit, reloadToken])

  const reload = useCallback(() => {
    setLoading(true)
    setReloadToken((token) => token + 1)
  }, [])

  return { tickets, loading, reload }
}
